export const messages = {
    "shared-link.footer.link.install": "Испробајте {brandName} бесплатно",
    "shared-link.footer.link.mobile": "{brandName} за мобилне уређаје",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Заштићени подаци",
    "shared-link.password-dialog-box.message": "Наведите лозинку да бисте приступили дељеним подацима",
    "shared-link.password-dialog-box.hint.password": "Лозинка",
    "shared-link.password-dialog-box.message.invalid-password": "Лозинка није тачна",
    "shared-link.form.button.open": "Отвори",
    "shared-link.page-not-found.title": "Страница није пронађена",
    "shared-link.page-not-found.message.main": "Страница коју сте тражили није пронађена.",
    "shared-link.page-not-found.message.description": "Веза је можда застарела или нисте тачно откуцали адресу.",
    "shared-link.page-not-found.message.error": "Код грешке: 404",
    "shared-link.restore-file.label.size": "Величина",
    "shared-link.restore-file.button.restore": "Преузми",
    "shared-link.links-table.column.name": "Име",
    "shared-link.links-table.column.size": "Величина",
    "shared-link.links-table.action.restore": "Преузми",
    "shared-link.links-table.action.restore-all": "Преузми све",
    "shared-link.side-bar.selected.title:plural": "Изабрано ставки: {count} | {count} ставка је изабрана | Изабрано ставки: {count} | Изабрано ставки: {count}",
    "shared-link.links-table.label.size": "Величина",
    "shared-link.links-table.message.empty-folder": "Ова фасцикла је празна"
};
